import React, { JSX } from 'react';
import { InputAdornment, MenuItem, OutlinedInput, Select } from '@mui/material';

// Types
import { DataValues } from '../../../types/Settings';

// Utils
import { StockDetailsContent } from '../../../constants/Constants';
import { ALL, selectMenuProps } from './stockDetails.constants';

// Common Components
import FormInputCollection from '../../common/FormInputCollection/FormInputCollection';

// Assets
import uldTypeIcon from '../../../assets/images/uld-type-icon.svg';

interface StockEquipmentTypeFilterProps {
  value: string | undefined;
  options: DataValues[] | undefined;
  onChange: (value: string | undefined) => void;
}

export default function StockEquipmentTypeFilter({ value, options, onChange }: StockEquipmentTypeFilterProps): JSX.Element {
  return (
    <FormInputCollection
      label={StockDetailsContent.equipmentTypeLabel}
      style={{
        marginRight: '1.5em',
      }}
    >
      <Select
        variant='outlined'
        id='equipmentType'
        name='equipmentType'
        value={value ?? ALL}
        size='small'
        style={{
          width: '150px',
        }}
        onChange={(event) => {
          const nextValue = event.target.value;

          onChange(nextValue === ALL ? undefined : nextValue);
        }}
        sx={{
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#E2E8F0',
          },
        }}
        MenuProps={selectMenuProps}
        input={
          <OutlinedInput
            startAdornment={
              <InputAdornment position='start'>
                <img src={uldTypeIcon} alt='' aria-hidden='true' />
              </InputAdornment>
            }
          />
        }
      >
        <MenuItem value={ALL}>{StockDetailsContent.allOptionLabel}</MenuItem>
        {options?.map((val, index: number) => (
          <MenuItem key={index} value={val.text}>
            {val.value}
          </MenuItem>
        ))}
      </Select>
    </FormInputCollection>
  );
}
